import React, { ReactNode } from 'react';

import { Box } from '@mui/material';

export const InfoBox = ({ children }: { children?: ReactNode }) => {
  return (
    <Box
      sx={theme => ({
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.text.primary,
        borderLeft: `4px solid ${theme.palette.primary.main}`
      })}
    >
      {children}
    </Box>
  );
};
